import { routeInfo } from './../../../../routeInfo';
import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import SignInForm from '../SignInForm/SignInForm';
import SignUpForm from '../SignUpForm/SignUpForm';
import * as actions from '../../../../redux/user/actions.user';
import logo from '../../../../assets/images/alan-studio-login-white.svg';
import logoMobile from '../../../../assets/images/alan-studio-login.svg';
import RequestNewPasswordForm from '../RequestNewPasswordForm/RequestNewPasswordForm';
import RestorePasswordForm from '../RestorePasswordForm/RestorePasswordForm';
import { Loader } from '../../../components/Loader/Loader';
import AccountHasNotVerifiedPopup from '../AccountHasNotVerifiedPopup/AccountHasNotVerifiedPopup';
import getPageTitle from '../../../../services/mini/getPageTitle';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import LoginFormSubtitle from '../LoginFormSubtitle/LoginFormSubtitle';
import { EmailSentForm } from '../EmailSentForm/EmailSentForm';
import TopMenu from '../../../components/TopMenu/TopMenu';
import isLocalStorageAvailable from '../../../../services/mini/isLocalStorageAvailable';
import '../../../../services/Navigator';

class LoginPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            email: ''
        };
    }

    componentDidMount() {
        this.needToShowResendEmailPopup();
        document.title = getPageTitle();
    }

    componentWillUnmount() {
        // if (window.alanBtnInstance) {
        //     window.alanBtnInstance.remove();
        // }
    }

    componentDidUpdate() {
        this.needToShowResendEmailPopup();
    }

    onEmailChange = ({ email }) => {
        this.setState({ email });
    }

    needToShowResendEmailPopup() {
        let {
            email,
            verificationEmailInfoData
        } = this.props;

        if (verificationEmailInfoData && verificationEmailInfoData.showResendPopup) {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <AccountHasNotVerifiedPopup
                            onClose={() => {
                                onClose();
                                this.props.resetVerificationEmailInfoData();
                            }}
                            email={email} {...verificationEmailInfoData} />
                    );
                }
            });
        }
    }

    sendVerifySignUpRequest = (param) => {
        return this.props.verifySignUp(param);
    }

    render() {
        const {
            showLogInForm,
            hex,
            verify,
            code,
            emailSent,
            logInInProcess,
            authorizationInProcess,
            requestPasswordRecovery,
            passwordRecovery,
            restorePassword,
            checkIfRestorePasswordAvailable,
            accountType,
            invitationCode,
            stateFromUrl,
            features
        } = this.props;

        let showTabs = true,
            showWelcomeStudioBlock = true,
            content;

        if (emailSent) {
            showTabs = false;
        }

        let disableEmail;

        if (invitationCode) {
            disableEmail = false;
        } else {
            disableEmail = this.props.email ? true : false;
        }

        content = showLogInForm ?
            <SignInForm
                verify={verify}
                logInInProcess={logInInProcess}
                sendVerifySignUpRequest={this.sendVerifySignUpRequest}
                accountType={accountType}
                hex={hex}
                code={code}
                stateFromUrl={stateFromUrl}
                invitationCode={invitationCode}
                email={this.props.email || this.state.email}
                onEmailChange={this.onEmailChange} /> :
            <SignUpForm
                accountType={accountType}
                disableEmail={disableEmail}
                email={this.props.email || this.state.email}
                code={code}
                invitationCode={invitationCode}
                logInInProcess={logInInProcess}
                onEmailChange={this.onEmailChange} />;

        if (emailSent) {
            showWelcomeStudioBlock = false;
            content = <EmailSentForm />;
        }

        if (requestPasswordRecovery) {
            showWelcomeStudioBlock = false;
            showTabs = false;
            content = <RequestNewPasswordForm email={this.props.email || this.state.email} />;
        }

        if (passwordRecovery) {
            showWelcomeStudioBlock = false;
            showTabs = false;
            content = <RestorePasswordForm
                email={this.props.email}
                hex={hex}
                checkIfRestorePasswordAvailable={checkIfRestorePasswordAvailable}
                restorePassword={restorePassword} />;
        }

        if (authorizationInProcess || features === null) {
            return (
                <div className="login-page auth-status-unknown">
                    <Loader theme="light" size="big" center={true} />
                </div>
            );
        }

        return (
            <div className="login-page">
                <TopMenu white={true} />
                <div className="login-page_internal">
                    <div className="login-page_internal-wrapper">
                        <div className={`login-page_internal-wrapper_content ${authorizationInProcess && 'with-loader'}`}>
                            {showTabs &&
                                <div className="login-page_tabs hoverable">
                                    <Link to={routeInfo.register.url()}
                                        className={`login-page_tabs_tab ${!showLogInForm && 'active'}`}
                                        activeClassName="active">Sign Up</Link>
                                    <Link to={routeInfo.login.url()}
                                        className={`login-page_tabs_tab ${showLogInForm && 'active'}`}>
                                        Sign In
                                    </Link>
                                    <div className="login-page_tabs_line" />
                                </div>}

                            {showWelcomeStudioBlock && <div className="login-page_mobile-header">
                                <LoginFormSubtitle title={!showLogInForm ? 'Welcome to' : 'Nice to see you again in'} />
                                <img src={logoMobile} className="login-page_mobile-header_alan-logo" />
                            </div>}
                            {content}
                        </div>
                        <div className="login-page_internal-wrapper_info">
                            {(showLogInForm || requestPasswordRecovery || passwordRecovery) ? 'Nice to see you again in' : 'Welcome to'}
                            <img src={logo} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ user, config }, ownProps) {
    let hex, email, code,
        invitationCode, stateFromUrl;
    if (ownProps.params && ownProps.params.hex) {
        hex = ownProps.params.hex;
    }
    if (ownProps.params && ownProps.params.email) {
        email = ownProps.params.email;
    }
    if (ownProps.location.query && ownProps.location.query.code) {
        code = ownProps.location.query.code;
    }
    if (ownProps.location.query && ownProps.location.query.invitationCode) {
        invitationCode = ownProps.location.query.invitationCode;
    }
    if (ownProps.location.query && ownProps.location.query.state) {
        stateFromUrl = ownProps.location.query.state;
    }

    return {
        showLogInForm: ownProps.route.signIn,
        accountType: ownProps.route.accountType,
        verificationEmailInfoData: user.verificationEmailInfoData,
        emailSent: ownProps.route.emailSent,
        verify: ownProps.route.verify,
        requestPasswordRecovery: ownProps.route.requestPasswordRecovery,
        passwordRecovery: ownProps.route.passwordRecovery,
        logInInProcess: user.logInInProcess,
        accountVerificationIsInInProcess: user.accountVerificationIsInInProcess,
        authorizationInProcess: user.authorizationInProcess,
        features: config.features,
        hex,
        email,
        code,
        invitationCode,
        stateFromUrl
    };
}

function mapDispatchToProps(dispatch) {
    return {
        verifySignUp: (param) => asyncDispatch(actions.verifySignUp, dispatch, param),
        resetVerificationEmailInfoData: () => dispatch(actions.resetVerificationEmailInfoData()),
        restorePassword: (param) => dispatch(actions.restorePassword(param)),
        checkIfRestorePasswordAvailable: (param) => asyncDispatch(actions.checkIfRestorePasswordAvailable, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);